import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, MapPin, Search } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { toast } from 'sonner';

const popularCities = [
  { name: 'Bengaluru, India', lat: 12.9716, lng: 77.5946 },
  { name: 'Mumbai, India', lat: 19.0760, lng: 72.8777 },
  { name: 'Delhi, India', lat: 28.7041, lng: 77.1025 },
  { name: 'Hyderabad, India', lat: 17.3850, lng: 78.4867 },
  { name: 'Chennai, India', lat: 13.0827, lng: 80.2707 },
  { name: 'Kolkata, India', lat: 22.5726, lng: 88.3639 },
  { name: 'Pune, India', lat: 18.5204, lng: 73.8567 },
  { name: 'Ahmedabad, India', lat: 23.0225, lng: 72.5714 },
];

export default function LocationSelector() {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCity, setSelectedCity] = useState(null);

  const handleSelectCity = (city) => {
    setSelectedCity(city);
    localStorage.setItem('userLocation', JSON.stringify({ lat: city.lat, lng: city.lng }));
    localStorage.setItem('cityName', city.name);
    toast.success(`Location set to ${city.name}`);
    navigate('/home');
  };

  const handleUseCurrentLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const location = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };
          localStorage.setItem('userLocation', JSON.stringify(location));
          toast.success('Using current location');
          navigate('/home');
        },
        (error) => {
          toast.error('Failed to get location');
        }
      );
    }
  };

  const filteredCities = popularCities.filter(city =>
    city.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white border-b border-gray-200 sticky top-0 z-50">
        <div className="flex items-center gap-4 px-4 py-4">
          <button onClick={() => navigate('/home')}>
            <ArrowLeft className="w-6 h-6 text-gray-700" />
          </button>
          <h1 className="text-xl font-bold text-gray-900">Select Location</h1>
        </div>
      </header>

      <main className="p-4">
        {/* Use Current Location */}
        <Button
          onClick={handleUseCurrentLocation}
          className="w-full mb-6 bg-orange-600 hover:bg-orange-700 rounded-xl py-6 text-base"
        >
          <MapPin className="w-5 h-5 mr-2" />
          Use Current Location
        </Button>

        {/* Search */}
        <div className="relative mb-6">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
          <Input
            type="text"
            placeholder="Search for a city..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="pl-10 rounded-xl"
          />
        </div>

        {/* Popular Cities */}
        <div>
          <h2 className="text-sm font-semibold text-gray-500 uppercase mb-3">Popular Cities</h2>
          <div className="space-y-2">
            {filteredCities.map((city, idx) => (
              <button
                key={idx}
                onClick={() => handleSelectCity(city)}
                className="flex items-center gap-3 w-full p-4 bg-white rounded-xl border border-gray-200 hover:border-orange-500 hover:bg-orange-50 transition"
              >
                <MapPin className="w-5 h-5 text-orange-600" />
                <span className="font-medium text-gray-900">{city.name}</span>
              </button>
            ))}
          </div>
        </div>
      </main>
    </div>
  );
}